import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/icon/scan-blue-grey.svg'


const _hoisted_1 = { class: "sm:flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Voucher Diskon", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "redeem"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", {
  class: "ml-3",
  style: {"color":"black"}
}, "Redeem", -1)
const _hoisted_6 = {
  key: 0,
  class: "mt-3 sm:mt-0"
}
const _hoisted_7 = { class: "grid sm:grid-cols-2 gap-10" }
const _hoisted_8 = { class: "header-card" }
const _hoisted_9 = {
  key: 0,
  class: "bg-white px-1 py-1 rounded-md text-sm absolute mx-3 my-1 hover:text-primary gap-2 cursor-pointer flex items-center",
  style: {"right":"0"}
}
const _hoisted_10 = { class: "text-black hover:text-yellow-500 font-semibold" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "pi pi-copy" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "text-black hover:text-yellow-500 font-semibold" }, " Download ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "pi pi-download" }, null, -1)
const _hoisted_14 = { class: "content-card mt-5" }
const _hoisted_15 = { class: "flex w-full justify-between items-center mb-2" }
const _hoisted_16 = { class: "flex w-full justify-between" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "text-color-grey text-sm" }, "Berlaku Sampai", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-color-grey text-sm"
}
const _hoisted_19 = {
  key: 1,
  class: "color-red text-sm font-semibold"
}
const _hoisted_20 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_21 = { class: "font-semibold text-xl text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_DialogScanSouvenir = _resolveComponent("DialogScanSouvenir")
  const _component_DialogPrintSouvenir = _resolveComponent("DialogPrintSouvenir")
  const _directive_clipboard = _resolveDirective("clipboard")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, _createSlots({
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Voucher",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true),
            (_ctx.checkPermission(_ctx.PermissionEnum.ListAllMyVoucher))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "font-semibold p-button-outlined-orange p-button-sm rounded-md ml-3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRedeemDialog()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.route.meta.permission.read)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_InputIconRightGrey, {
                  placeholder: "Cari Disini ...",
                  modelValue: _ctx.inputSearch,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputSearch = $event)),
                  canClick: true,
                  onSubmitInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAllData(_ctx.inputSearch))),
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.getAllData(_ctx.inputSearch)), ["enter"])),
                  type: _ctx.$enumBase.input.text,
                  icon: _ctx.$icon.svg.searchEva
                }, null, 8, ["modelValue", "type", "icon"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.route.meta.permission.read)
          ? (_openBlock(), _createBlock(_component_TabView, {
              key: 0,
              class: "color-primary mt-5 mb-5",
              activeIndex: _ctx.currentTab,
              "onUpdate:activeIndex": _cache[6] || (_cache[6] = ($event: any) => (_ctx.currentTab = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TabPanel, { header: "Voucher Khusus" }),
                _createVNode(_component_TabPanel, { header: "Voucher Berjangka" })
              ]),
              _: 1
            }, 8, ["activeIndex"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.route.meta.permission.read)
        ? {
            name: "content",
            fn: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (data) => {
                  return (_openBlock(), _createBlock("div", {
                    class: ["card-voucher-discount", data.IsActive ? 'bg-white' : 'background-blue-grey-lighten-5'],
                    key: data.Id
                  }, [
                    _createVNode("div", _hoisted_8, [
                      (data.MsVoucherCodes.length > 0 && _ctx.currentTab == 0)
                        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_9, [
                            _createVNode("p", _hoisted_10, [
                              _createTextVNode(_toDisplayString(data.MsVoucherCodes[0].Code) + " ", 1),
                              _hoisted_11
                            ])
                          ], 512)), [
                            [_directive_clipboard, data.MsVoucherCodes[0].Code, "copy"],
                            [_directive_clipboard, _ctx.successCopy, "success"],
                            [_directive_clipboard, _ctx.errorCopy, "error"]
                          ])
                        : (_openBlock(), _createBlock("div", {
                            key: 1,
                            class: "bg-white px-1 py-1 rounded-md text-sm absolute mx-3 my-1 hover:text-primary gap-2 cursor-pointer flex items-center",
                            style: {"right":"0"},
                            onClick: ($event: any) => (_ctx.downloadText(data.MsVoucherCodes))
                          }, [
                            _hoisted_12,
                            _hoisted_13
                          ], 8, ["onClick"])),
                      (data.Filename)
                        ? (_openBlock(), _createBlock("img", {
                            key: 2,
                            src: data.Filename,
                            class: "rounded-lg w-full"
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("p", {
                          class: "text-black font-semibold hover-primary cursor-pointer",
                          onClick: ($event: any) => (_ctx.detailVoucher(data))
                        }, _toDisplayString(data.Name), 9, ["onClick"]),
                        _createVNode(_component_InputSwitch, {
                          class: "switch-og z-10",
                          disabled: !_ctx.route.meta.permission.update,
                          onChange: ($event: any) => (_ctx.changeIsActive(data)),
                          modelValue: data.IsActive,
                          "onUpdate:modelValue": ($event: any) => (data.IsActive = $event)
                        }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        (data.IsActive)
                          ? (_openBlock(), _createBlock("p", _hoisted_18, _toDisplayString(data.TanggalBerlaku), 1))
                          : (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString("Sudah Berakhir")))
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          }
        : undefined,
      (_ctx.route.meta.permission.read)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              (_ctx.dataSource.length > 0)
                ? (_openBlock(), _createBlock(_component_Paginator, {
                    key: 0,
                    rows: _ctx.filters.top,
                    totalRecords: _ctx.filters.totalRecords,
                    onPage: _ctx.onPage
                  }, null, 8, ["rows", "totalRecords", "onPage"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1024),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowDialog,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowDialog = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: true
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_20, [
          _createVNode("span", null, [
            _createVNode("h6", _hoisted_21, _toDisplayString(_ctx.dataDetail.Name), 1)
          ]),
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowDialog = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.isShowDialogRedeem)
      ? (_openBlock(), _createBlock(_component_DialogScanSouvenir, {
          key: 0,
          isShowDialog: _ctx.isShowDialogRedeem,
          onHideDialog: _ctx.hideRedeemDialog,
          onOpenPrintDialog: _ctx.showPrintRedeemDialog,
          onInitVoucherCodeId: _ctx.initVoucherCodeId,
          onRescan: _ctx.showRedeemDialog
        }, null, 8, ["isShowDialog", "onHideDialog", "onOpenPrintDialog", "onInitVoucherCodeId", "onRescan"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDialogPrintRedeem)
      ? (_openBlock(), _createBlock(_component_DialogPrintSouvenir, {
          key: 1,
          isShowDialog: _ctx.isShowDialogPrintRedeem,
          myVoucherId: _ctx.myVoucherId,
          voucherData: _ctx.voucherData,
          voucherCodeId: _ctx.voucherCodeId,
          onRescan: _ctx.showRedeemDialog,
          onHideDialog: _ctx.hidePrintRedeemDialog
        }, null, 8, ["isShowDialog", "myVoucherId", "voucherData", "voucherCodeId", "onRescan", "onHideDialog"]))
      : _createCommentVNode("", true)
  ]))
}